import { handleTrackingButtonOnClick } from "./index";

export default function SecondaryButton({ text, onClick }: any) {
  return (
    <>
      <button
        type="button"
        className="min-w-20 inline-flex h-8 items-center justify-center rounded border border-transparent bg-indigo-100 px-2.5 py-1.5 text-[14px] text-xs text-indigo-700 hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
        onClick={() => handleTrackingButtonOnClick(text, onClick)}
      >
        {text}
      </button>
    </>
  );
}
